// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rmdp-prime.rmdp-wrapper {
  border: 1px solid #8798ad;
}

.rmdp-prime .rmdp-calendar {
  padding: 0 !important;
}

.rmdp-prime .rmdp-header,
.rmdp-prime .rmdp-panel-header {
  border-bottom: 1px solid #8798ad;
  margin-top: 0 !important;
}

.rmdp-prime .rmdp-time-picker {
  border-top: 1px solid #8798ad;
  margin-bottom: 0 !important;
}

.rmdp-prime .rmdp-panel-body li {
  border-radius: 5px;
}

.rmdp-prime .rmdp-border-top {
  border-top: 1px solid #8798ad !important;
}

.rmdp-prime .rmdp-border-bottom {
  border-bottom: 1px solid #8798ad !important;
}

.rmdp-prime .rmdp-border-left {
  border-left: 1px solid #8798ad !important;
}

.rmdp-prime .rmdp-border-right {
  border-right: 1px solid #8798ad !important;
}

.rmdp-prime.ep-arrow::after {
  box-shadow: 0 0 6px #404050 !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-multi-date-picker/styles/layouts/prime.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".rmdp-prime.rmdp-wrapper {\n  border: 1px solid #8798ad;\n}\n\n.rmdp-prime .rmdp-calendar {\n  padding: 0 !important;\n}\n\n.rmdp-prime .rmdp-header,\n.rmdp-prime .rmdp-panel-header {\n  border-bottom: 1px solid #8798ad;\n  margin-top: 0 !important;\n}\n\n.rmdp-prime .rmdp-time-picker {\n  border-top: 1px solid #8798ad;\n  margin-bottom: 0 !important;\n}\n\n.rmdp-prime .rmdp-panel-body li {\n  border-radius: 5px;\n}\n\n.rmdp-prime .rmdp-border-top {\n  border-top: 1px solid #8798ad !important;\n}\n\n.rmdp-prime .rmdp-border-bottom {\n  border-bottom: 1px solid #8798ad !important;\n}\n\n.rmdp-prime .rmdp-border-left {\n  border-left: 1px solid #8798ad !important;\n}\n\n.rmdp-prime .rmdp-border-right {\n  border-right: 1px solid #8798ad !important;\n}\n\n.rmdp-prime.ep-arrow::after {\n  box-shadow: 0 0 6px #404050 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
